{
  "b455": {
    "id": "b455",
    "label": "Funktionen, die die Kapazität des respiratorischen und kardiovaskulären Systems zur Erbringung von Ausdauerleistungen betreffen",
    "inclusion": "Funktionen der Ausdauerleistung, der aeroben Kapazität, Belastbarkeit und Ermüdbarkeit",
    "exclusion": "Funktionen des kardiovaskulären Systems ; Funktionen des hämatologischen Systems ; Atmungsfunktionen ; Funktionen der Atemmuskulatur ; Weitere Atmungsfunktionen  "
  },
  "b735": {
    "id": "b735",
    "label": "Funktionen, die im Zusammenhang mit dem Ruhetonus der Muskeln und dem Widerstand bei passiver Bewegung stehen",
    "inclusion": "Funktionen, die mit dem Tonus einzelner Muskeln und Muskelgruppen, Muskeln einer einzelnen Extremität, einer Körperhälfte, der unteren Körperhälfte, aller Extremitäten, des Rumpfes und aller Muskeln des Körpers verbunden sind; Funktionsstörungen wie verminderter Muskeltonus, erhöhter Muskeltonus, Spastik",
    "exclusion": "Funktionen der Muskelkraft  , Funktionen der Muskelausdauer  "
  },
  "b750": {
    "id": "b750",
    "label": "Funktionen, die unwillkürliche Muskelkontraktionen, ausgelöst durch spezifische Stimuli, betreffen",
    "inclusion": "Funktionen der Streckreflexe, der automatischen lokalen Reflexe, der Reflexe durch schädigende Stimuli und andere exterozeptive Stimuli; Schutzreflexe, Bizepssehnenreflex, Radius-Periost-Reflex, Quadrizepsreflex, Patellarsehnenreflex, Achillessehnenreflex",
    "exclusion": ""
  },
  "b755": {
    "id": "b755",
    "label": "Funktionen, die unwillkürliche Kontraktionen großer Muskeln oder des ganzen Körpers, ausgelöst durch Körperhaltung, Gleichgewichts- und Schreckreaktionen, betreffen",
    "inclusion": "Funktionen der Reaktionen auf Lagewechsel, Aufrichtung, Körper-Anpassung sowie der Gleichgewichtsreaktionen, Stützreaktionen, Abwehrreaktionen",
    "exclusion": "Funktionen der motorischen Reflexe  "
  },
  "b760": {
    "id": "b760",
    "label": "Funktionen, die mit der Kontrolle und Koordination von willkürlichen Bewegungen verbunden sind",
    "inclusion": "Funktionen der Kontrolle einfacher und komplexer Willkürbewegungen, der Koordination von Willkürbewegungen, Stützfunktionen der Arme oder Beine, motorische Rechts-Links-Koordination, Auge-Hand-Koordination, Auge-Fuß-Koordination; Funktionsstörungen wie Kontroll- und Koordinationsprobleme, z.B. Dysdiadochokinese",
    "exclusion": "Funktionen der Muskelkraft ; Funktionen der unwillkürlichen Bewegungen  , Funktionen der Bewegungsmuster beim Gehen  "
  },
  "b770": {
    "id": "b770",
    "label": "Funktionen, die die Bewegungsmuster beim Gehen, Rennen oder anderen Bewegungsabläufen des gesamten Körpers betreffen",
    "inclusion": "Bewegungsmuster beim Gehen und Rennen; Funktionsstörungen wie spastisches, hemiplegisches, paraplegisches, asymmetrisches Gangbild, Hinken und steifes Gangbild",
    "exclusion": "Funktionen der Muskelkraft ; Funktionen des Muskeltonus ; Funktionen der Kontrolle von Willkürbewegungen ; Funktionen der unwillkürlichen Bewegungen  "
  },
  "d410": {
    "id": "d410",
    "label": "In eine und aus einer Körperposition zu gelangen und sich von einem Ort zu einem anderen zu bewegen, wie von einem Stuhl aufstehen, um sich in ein Bett zu legen, in eine und aus einer knienden oder hockenden Position gelangen",
    "inclusion": "Seine Körperposition aus einer liegenden, knienden oder hockenden, sitzenden oder stehenden Position ändern, sich beugen und seinen Körperschwerpunkt verlagern",
    "exclusion": "Sich verlagern  "
  },
  "d4103": {
    "id": "d4103",
    "label": "In oder aus einer sitzenden Position zu gelangen oder die Körperposition von einer sitzenden in jede andere Position zu wechseln, wie aufstehen oder sich hinlegen",
    "inclusion": "In eine sitzende Position mit gebeugten oder übergeschlagenen Beinen gelangen; in eine sitzende Position mit oder ohne Unterstützung der Füße gelangen",
    "exclusion": ""
  },
  "d4104": {
    "id": "d4104",
    "label": "In oder aus einer stehenden Position zu gelangen oder die Körperposition von einer stehenden in jede andere Position zu wechseln, wie sich hinlegen oder hinsetzen",
    "inclusion": "",
    "exclusion": ""
  },
  "d4105": {
    "id": "d4105",
    "label": "Den Rücken nach unten oder zur Seite zu beugen, wie beim Verbeugen oder beim Langen nach einem Gegenstand",
    "inclusion": "",
    "exclusion": ""
  },
  "d4106": {
    "id": "d4106",
    "label": "Während des Sitzens, Stehens oder Liegens sein Körpergewicht von einer Position zu einer anderen zu verlagern oder zu bewegen, wie während des Stehens sein Standbein wechseln",
    "inclusion": "",
    "exclusion": "Sich verlagern ; Gehen  "
  },
  "d4153": {
    "id": "d4153",
    "label": "Für eine erforderliche Zeit in einer sitzenden Position auf einer Sitzgelegenheit oder dem Boden zu verbleiben, wie an einem Pult oder Tisch sitzen",
    "inclusion": "Mit ausgestreckten oder übergeschlagenen Beinen mit oder ohne Unterstützung der Füße in einer sitzenden Position verbleiben",
    "exclusion": ""
  },
  "d4154": {
    "id": "d4154",
    "label": "Für eine erforderliche Zeit in einer stehenden Position zu verbleiben, wie in einer Schlange stehen",
    "inclusion": "Auf einer geneigten, rutschigen oder harten Oberfläche in stehender Position verbleiben",
    "exclusion": ""
  },
  "d420": {
    "id": "d420",
    "label": "Sich von einer Oberfläche auf eine andere zu bewegen, wie auf einer Bank entlang gleiten oder sich ohne Änderung der Körperposition aus dem Bett auf einen Stuhl bewegen",
    "inclusion": "Sich während des Sitzens oder Liegens verlagern",
    "exclusion": "Eine elementare Körperposition wechseln  "
  },
  "d430": {
    "id": "d430",
    "label": "Einen Gegenstand anzuheben oder etwas von einem Platz zu einem anderen zu tragen, wie eine Tasse anheben oder ein Kind von einem Zimmer in ein anderes tragen",
    "inclusion": "Mit den Händen, Armen, auf den Schultern, dem Kopf, dem Rücken oder der Hüfte anheben und absetzen",
    "exclusion": ""
  },
  "d440": {
    "id": "d440",
    "label": "Koordinierte Handlungen mit dem Ziel auszuführen, Gegenstände mit der Hand, den Fingern und dem Daumen aufzunehmen, zu handhaben und loszulassen, wie es für das Aufnehmen von Münzen von einem Tisch, für das Drehen einer Wählscheibe oder eines Knaufes erforderlich ist",
    "inclusion": "aufnehmen, ergreifen, handhaben, loslassen",
    "exclusion": "Gegenstände anheben und tragen  "
  },
  "d4400": {
    "id": "d4400",
    "label": "Einen kleinen Gegenstand mit den Händen und Fingern aufnehmen oder aufheben, wie einen Bleistift aufnehmen",
    "inclusion": "",
    "exclusion": ""
  },
  "d445": {
    "id": "d445",
    "label": "Koordinierte Handlungen auszuführen, die erforderlich sind, Gegenstände mit Händen und Armen zu bewegen oder zu handhaben, wie beim Drehen eines Türgriffs oder dem Werfen oder Fangen eines Gegenstands",
    "inclusion": "Gegenstände ziehen oder schieben; nach etwas langen; Hände oder Arme drehen oder verdrehen; werfen; fangen",
    "exclusion": "Feinmotorischer Handgebrauch  "
  },
  "d450": {
    "id": "d450",
    "label": "Sich zu Fuß auf einer Oberfläche Schritt für Schritt so fortzubewegen, dass stets wenigstens ein Fuß den Boden berührt, wie beim Spazieren, Schlendern, Vorwärts-, Rückwärts- oder Seitwärtsgehen",
    "inclusion": "Kurze oder weite Entfernungen gehen; auf unterschiedlichen Oberflächen gehen; Hindernisse umgehen",
    "exclusion": "Sich verlagern ; Sich auf andere Weise fortbewegen  "
  },
  "d4500": {
    "id": "d4500",
    "label": "Weniger als einen Kilometer zu gehen, wie in Räumen umher oder auf Korridoren entlang gehen, innerhalb eines Gebäudes oder für kurze Entfernungen außerhalb",
    "inclusion": "",
    "exclusion": ""
  },
  "d4502": {
    "id": "d4502",
    "label": "Auf ansteigenden oder abfallenden, unebenen oder sich bewegenden Oberflächen zu gehen, wie auf Gras, Kies, Eis oder Schnee gehen, oder auf einem Schiff, in einem Zug oder einem anderen Fahrzeug gehen",
    "inclusion": "",
    "exclusion": ""
  },
  "d455": {
    "id": "d455",
    "label": "Sich auf andere Weise als gehend von einem Ort zu einem anderen fortzubewegen, wie über einen Fels klettern oder eine Straße entlang rennen, springen, spurten, hüpfen, einen Purzelbaum schlagen oder um Hindernisse rennen",
    "inclusion": "Krabbeln/robben, klettern/steigen, rennen, joggen, springen und schwimmen",
    "exclusion": "Sich verlagern ; Gehen  "
  },
  "d4551": {
    "id": "d4551",
    "label": "Den ganzen Körper über Oberflächen oder Objekte auf- oder abwärts zu bewegen, wie bei Stufen, Steinen/Felsen, Leitern, Treppen, Kantsteinen oder anderen Objekten",
    "inclusion": "",
    "exclusion": ""
  },
  "e340": {
    "id": "e340",
    "label": "Personen, die Dienstleistungen erbringen, welche erforderlich sind, um Personen bei ihren täglichen Aktivitäten, bei der Erhaltung und Durchführung der Arbeit am Arbeitsplatz, im Bildungs-/Ausbildungsbereich oder in anderen Lebenssituationen zu unterstützen, wobei dieser Dienst entweder durch öffentliche oder private Träger erfolgt oder auf ehrenamtlicher Basis, wie Anbieter von Hilfen bei Hausarbeit und Haushaltsführung, personeller Assistenz, Assistenz beim Transport und anderen Unterstützungserfordernissen durch bezahlte Hilfen, Kindermädchen und andere, die vornehmlich Betreuungs- oder Pflegeleistungen erbringen",
    "inclusion": "",
    "exclusion": "Engster Familienkreis  , Bekannte, Seinesgleichen (Peers), Kollegen, Nachbarn und andere Gemeindemitglieder  "
  }
}